import React from "react";
import styled from "styled-components";

import { useQueryGetUnitVocabulary } from "@examspark/common-app";
import { Text, RouterLink, Toolbar, VSpace } from "@examspark/common-ui";
import { IconRedirectLine } from "@examspark/common-ui/dist/components/icons";
import { colorFromTheme } from "@examspark/common-ui/dist/utils/color";
import { ParsedTCMPCUnit } from "@examspark/types";

import UnitContent from "../common/UnitContent";

import UnitSummaryVocabulary from "./unit-summary/UnitSummaryVocabulary";
import UnitTeks from "./UnitTeks";

const Styled = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 0 0 1px ${colorFromTheme("surface5")};
`;

const StyledUnitSummary = styled.div`
  padding: 0.5rem 1rem;

  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const StyledTitleToolbar = styled(Toolbar)`
  gap: 1.5rem;
`;

type UnitSummaryProps = {
  unit: ParsedTCMPCUnit;
};
const UnitSummary = ({ unit }: UnitSummaryProps) => {
  const vocabulariesQuery = useQueryGetUnitVocabulary(unit);
  return (
    <>
      <VSpace size="3rem">
        <VSpace>
          <StyledTitleToolbar>
            <Text.H2>{unit.name} </Text.H2>
            <RouterLink to={`/unit/${unit.id}`}>
              Read Entire IFD <IconRedirectLine width="16" />
            </RouterLink>
          </StyledTitleToolbar>
          <Styled>
            <StyledUnitSummary>
              <UnitContent content={unit.data.introduction ?? ""} />
            </StyledUnitSummary>
          </Styled>
        </VSpace>
        <UnitTeks unit={unit} />
        {!!vocabulariesQuery.data?.length && (
          <UnitSummaryVocabulary unit={unit} />
        )}
      </VSpace>
    </>
  );
};
export default UnitSummary;
